// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"73389ec2","107":"9a436e4a","133":"bcd66461","137":"9032abb4","191":"64ace045","219":"cd74697a","251":"eae66a43","359":"090bec14","461":"7b9e54c6","518":"dcbef608","565":"4a06a002","859":"add597bf","889":"ee7881cc","917":"01b67763","973":"63b9075d"}[chunkId] + ".chunk.js";
};